module.exports = __webpack_public_path__ + "img/pslc0bcjm1cqp1osnkaeunifm0gjodjy7gc9a1c05c-f180-4511-86ed-0d48e30deb5f.ece0381b.png";